<div class="div-action-top">
  <div class="left">
    <div class="form-filter ant-form ant-form-inline">
      <input style="width: 200px" [(ngModel)]="searchText" (ngModelChange)="doSearch()" nz-input
             placeholder="Tìm mã phiếu"/>
      <button nzSize="default" nz-button nzType="primary" class="btn-add-asset" type="button" (click)="showModalAdd()" *ngIf="checkAdd">
        <em class="fas fa-plus fa-fw"></em> Thêm phiếu xuất kho
      </button>
    </div>
  </div>
</div>

<!-- Hiển thị thông tin phiếu -->
<div class="data-table">
  <nz-table #basicTable [nzData]="filterData" (nzCurrentPageDataChange)="currentPageDataChange($event)"
            [nzPageSizeOptions]="pageSize" [nzPageSize]="defaultPage" nzSize="small" nzShowSizeChanger
            [nzShowTotal]="rangeTemplate" [nzLoading]="loading"
            [nzScroll]="{x: '1000px'}"
  >
    <thead>
    <tr>
      <th nzShowCheckbox nzLeft="0px" nzWidth="50px" [(nzChecked)]="isAllDisplayDataChecked"
          [nzIndeterminate]="isIndeterminate" (nzCheckedChange)="checkAllRow($event)"></th>
      <th nzLeft class="text-nowrap" width="50px">#</th>
      <th nzLeft class="text-nowrap" width="150px">Mã phiếu</th>
      <th class="text-nowrap" width="200px">Mô tả phiếu</th>
      <th class="text-nowrap" width="120px">Thu hồi từ kho</th>
      <th class="text-nowrap" width="150px">Thời gian</th>
      <th class="text-nowrap" width="80px">Người xuất</th>
      <!-- <th class="text-nowrap">Tiền thanh toán</th>
      <th class="text-nowrap">Mã HĐ thanh toán</th> -->
      <th nzRight class="text-nowrap" width="90px"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of basicTable.data;let i = index;">
      <td nzLeft nzShowCheckbox [(nzChecked)]="mapOfCheckedId[data.id]" (nzCheckedChange)="refreshStatus()" nzLeft="0px"
          nzWidth="50px"></td>
      <td nzLeft class="text-nowrap">{{getRowIndex(i, basicTable.nzPageIndex, basicTable.nzPageSize)}}</td>
      <td nzLeft class="">{{data.code}}</td>
      <td class="">{{data.description}}</td>
      <td class="text-nowrap">
        <strong>{{data.fromWareHouse ? data.fromWareHouse.name : ''}}</strong>
      </td>
      <!--<td class="">{{ data.recipient }}</td>-->
      <td class="text-nowrap">{{ data.dateLog | date:'dd/MM/yyyy HH:mm' }}</td>
      <td class="text-nowrap">{{ data.userIdCreatedNavigation?.fullname }}</td>
      <td nzRight class="text-nowrap" width="90px">
        <button nz-button nzSize="small" nzType="danger" class="btn-right" (click)="showConfirm(data.id)"
                *ngIf="checkDelete"><span class="fa fa-times fa-fw"></span>
        </button>
        <!--<button nz-button nzSize="small" nzType="default" class="btn-right" (click)="showModalUpdate(data)"
                *ngIf="checkUpdate"><span class="fa fa-edit fa-fw"></span>
        </button>-->
        <button nz-button nzSize="small" nzType="primary" class="btn-right" (click)="showDetails(data)"
                *ngIf="checkDetails"><span class="fa fa-info fa-fw"></span>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <ng-template #rangeTemplate let-range="range" let-total>
    {{ range[0] }}-{{ range[1] }} {{'of' | translate }} {{ total }} {{'items' | translate }}
  </ng-template>
</div>

<!-- Thêm, sửa phiếu xuất -->
<nz-modal *ngIf="selectedWarehouse" nzWidth="1200px" [(nzVisible)]="isVisibleAdd" nzClosable="false" [nzTitle]="title1" nzMaskClosable="false">
  <ng-template #title1>
    Thông tin phiếu thu hồi, trả vỏ
    <div class="pull-right icon-close">
      <em (click)="handleCancel()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>
  <div *ngIf="enableEdit">
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Thu hồi vỏ từ kho</label>
      <nz-form-control [nzSpan]="16" style="position: relative;">
        <nz-select [disabled]="viewOnly" nzShowSearch nzAllowClear nzPlaceHolder="Chọn thu hồi, trả vỏ" [(ngModel)]="selectedData.fromWareHouseId" style="width: 100%">
          <nz-option *ngFor="let item of selectedWarehouse.inverseParent" [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
        </nz-select>
      </nz-form-control>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Mã phiếu</label>
      <nz-form-control [nzSpan]="16" style="position: relative;">
        <input [disabled]="isEdit || viewOnly" [(ngModel)]="selectedData.code" nz-input placeholder="Mã sẽ tự thêm nếu ô bỏ trống .."/>
      </nz-form-control>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Mô tả phiếu<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="16">
        <input [disabled]="viewOnly" nz-input placeholder="Mô tả phiếu" [(ngModel)]="selectedData.description"/>
      </div>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Scan barcode</label>
      <div nz-col [nzSpan]="16">
        <nz-switch [disabled]="viewOnly" nzSize="default" [(ngModel)]="selectedData.scanBarcode"></nz-switch>
      </div>
    </div>
    <div class="input-wrap nz-row row-width" *ngIf="!viewOnly">
      <label class="title-detail text-text" nz-col [nzSpan]="4">&nbsp;</label>
      <div nz-col [nzSpan]="16">
        <input [disabled]="viewOnly" (ngModelChange)="handleBarcode($event)" style="width: 300px;" *ngIf="selectedData.scanBarcode" nz-input placeholder="Paste code here" type="text" [(ngModel)]="selectedData.parcelDetailCode"/>
      </div>
    </div>
  </div>
  <!-- Thông tin chi tiết phiếu xuất -->
  <div class="div-action" *ngIf="!viewOnly">
    <button *ngIf="!selectedData.scanBarcode" nz-button nzSize="small" nzType="primary" class="btn-add-asset btn-right" type="button"
            (click)="addDetailInput()">
      <em class="fas fa-plus fa-fw"></em>
    </button>
    <div class="clearfix"></div>
  </div>
  <button *ngIf="viewOnly" nz-button nzSize="small" nzType="primary" class="btn-add-asset btn-right" type="button"
          (click)="exportPDF()">
    <em class="fas fa-file-pdf fa-fw"></em>
    In phiếu
  </button>
  <nz-table [nzShowPagination]="false"  #spreadsheet width="100%" [nzScroll]="{ y: '250px' }" id="detailTable">
    <thead>
    <tr>
      <th nzWidth="80px">STT</th>
      <th nzWidth="120px">Barcode<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="180px">Mã - Tên hóa chất<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Code NSX<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Hãng/Nước SX<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Số lô<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Hạn sử dụng<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Seri<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Quy cách đóng gói<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="100px">Đơn vị<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="120px">Số lượng<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="80px"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of selectedData.warehouseEvictionDetails; let i = index">
      <td>
        {{ i + 1 }}
      </td>
      <td>
        {{item.parcelDetailCode}}
      </td>
      <td>
        {{item.chemical.name}}
      </td>
      <td>
        {{item.manufacturerCode}}
      </td>
      <td>
        {{item.madeIn}}
      </td>
      <td>
        {{item.batchNumber}}
      </td>
      <td>
        {{item.expiredDate | date: 'dd-MM-yyyy'}}
      </td>
      <td>
        {{item.serialNumber}}
      </td>
      <td>
        {{ item.chemical?.packingQuantity }} {{ item.unitTypeText }}/{{ item.chemical?.packing }}
      </td>
      <td>
        {{item.unitTypeText}}
      </td>
      <td>
        {{item.amount}}
      </td>
      <td>
        <button *ngIf="!viewOnly" nzSize="small" nz-button nzType="danger" class="button-update btn-right" (click)="deleteDetail(item)">Xóa
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <div *nzModalFooter>
    <button nz-button (click)="handleCancel()">{{'cancel' | translate }}</button>
    <button [nzLoading]="loadingButton" nz-button *ngIf="!viewOnly" nzType="primary" (click)="handleOk()" class="button-submit">{{'save' | translate }}</button>
  </div>
</nz-modal>
